module.exports = __webpack_public_path__ + "img/bus.b2f36fcf.svg";